/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * ArrowLeftIcon - Auto-generated from icon.js
 */
export const ArrowLeftIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M7.99875 12.0013C7.99829 11.7676 8.07967 11.5412 8.22875 11.3613L13.2287 5.36125C13.3985 5.15704 13.6424 5.02861 13.9068 5.00423C14.1713 4.97985 14.4345 5.06151 14.6387 5.23125C14.843 5.40099 14.9714 5.6449 14.9958 5.90933C15.0201 6.17375 14.9385 6.43704 14.7687 6.64125L10.2887 12.0013L14.6087 17.3613C14.6918 17.4635 14.7538 17.5812 14.7913 17.7076C14.8287 17.8339 14.8408 17.9664 14.8269 18.0974C14.8129 18.2285 14.7732 18.3554 14.7101 18.4711C14.6469 18.5867 14.5615 18.6887 14.4587 18.7713C14.3559 18.8628 14.2353 18.9322 14.1044 18.975C13.9736 19.0178 13.8353 19.0331 13.6982 19.0199C13.5611 19.0068 13.4283 18.9655 13.3079 18.8986C13.1875 18.8317 13.0823 18.7407 12.9987 18.6313L8.16875 12.6313C8.04323 12.4462 7.98338 12.2244 7.99875 12.0013Z"
			fill="#222222"
		/>
	</svg>
);

export default ArrowLeftIcon;
